import React, { useContext, useEffect, useRef, useState } from 'react';
import { AuthContext } from 'context/auth';
import { Box, Button, FormControl, FormLabel, Heading, Input, NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, Textarea, Text, Divider, useToast, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Tag, Center, Spinner, InputGroup, InputRightElement, Card, CardBody, Flex, Spacer, CloseButton } from '@chakra-ui/react';
import { config, mfrProcessSelectables, subSystemSelectables, materialSelectables, finishSelectables, prioritySelectables } from 'util/constants';
import { CreatableSelect, Select } from "chakra-react-select";
import { MCFFormsContext } from 'context/mcfforms';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';

export default function RejectForm(props) {
    const { user } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    const { MCFForms, getMCFForms } = useContext(MCFFormsContext);
    const { objectId: objectIdParam } = useParams();
    const [authorizedUser, setAuthorizedUser] = useState(false);
    const [form, setForm] = useState(null);
    const [reasons, setReasons] = useState([]);
    const [highlightButton, setHighlightButton] = useState(false);
    const reasonInputRef = useRef(null);
    const timeLoaded = useRef(null);
    const origReasons = useRef(null);
    const notFixed = useRef(null);
    
    const navigate = useNavigate();

    const errorToast = () => {
        toast({
            title: 'Error',
            description: 'There was an error processing your request',
            status: 'error',
            duration: 5000,
            isClosable: true,
        });
    }

    const handleSubmit = (e) => {
        setLoading(true);
        let formData = {};
        
        fetch(`/transactions/getMCFForm/${objectIdParam}`, {
            method: 'GET',
        }).then(response => {
            if (response.status !== 200) {
                throw `${response.status}: ${response.statusText}`
            }
            return response.json();
        }
        ).then(data => {
            if (new Date(timeLoaded.current).getTime() > new Date(data.docs.updatedAt).getTime())
            {
                formData.rejectReasons = reasons;
                if (JSON.stringify(reasons) !== JSON.stringify(notFixed.current))
                {
                    fetch(`/transactions/rejectMCFForm/${objectIdParam}`, {
                        method: 'POST',
                        // We convert the React state to JSON and send it as the POST body
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(formData)
                    }).then(response => {
                        if (response.status !== 200) {
                            throw `${response.status}: ${response.statusText}`
                        }
                        return response.text();
                    // @ts-ignore
                    }).then(function(data) {
                        // Success
                        getMCFForms(() => {
                            setTimeout(() => {
                                toast({
                                    title: 'Part MCF Updated',
                                    status: 'success',
                                    duration: 5000,
                                    isClosable: true,
                                });
                                setLoading(false);
                                navigate('/');
                            }, 500);
                        });
                    })
                    .catch(err => {
                        setLoading(false);
                        console.log(err);
                        errorToast();
                    });
                } else {
                    console.log(reasonInputRef.current.value.length);
                    if (reasonInputRef.current.value.length > 0)
                    {
                        setHighlightButton(true);
                    }
                    toast({
                        title: 'No changes applied',
                        status: 'info',
                        duration: 5000,
                        isClosable: true,
                    });
                    setLoading(false);
                }
            } else {
                toast({
                    title: 'Error',
                    description: 'Current document is outdated. Please refresh.',
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                });
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            errorToast();
            console.error(err);
        });
    }

    useEffect(() => {
        try
        {
            fetch(`/transactions/getMCFForm/${objectIdParam}`, {
                method: 'GET',
            }).then(response => {
                if (response.status !== 200) {
                    throw `${response.status}: ${response.statusText}`
                }
                return response.json();
            }
            ).then(data => {
                origReasons.current = data.docs.rejection.recommendations.map(e => { return e.recommendation; });
                notFixed.current = data.docs.rejection.recommendations.filter(e => {
                        if (!e.fixed) {
                            return e.recommendation;
                        }
                }).map(e => { return e.recommendation });
                if (notFixed.current.length > 0) setReasons(notFixed.current);
                setTimeout(() => setForm(data.docs), 250);
                if (!data.docs.approved && !data.docs.manufactured && (data.docs.googleId === user.googleId || user.admin))
                {
                    setAuthorizedUser(true);
                }
                timeLoaded.current = data.timestamp;
            }).catch(err => {
                console.error(err);
            });

        } catch (e)
        {
            console.log(e);
        }
    }, []);

    const handleAddReason = () => {
        if (reasonInputRef.current.value) {
            setHighlightButton(false);
            setReasons([...reasons, reasonInputRef.current.value]);
            reasonInputRef.current.value = '';
        }
    }

    if (!form)
    {
        return (<>
        <Box margin={'0 auto'} mt={"1em"} width={{ base: '85%', md: '66%', lg: '50%' }}>
            <Tag backgroundColor={'white'}>
                <Breadcrumb separator={<ChevronRightIcon color='gray.500' />}>
                    <BreadcrumbItem>
                        <BreadcrumbLink as={RouterLink} to={`/`}>Home</BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                        <BreadcrumbLink>Edit Form</BreadcrumbLink>
                    </BreadcrumbItem>
                </Breadcrumb>
            </Tag>
            <Center><Spinner mt={'2em'} size='lg' /></Center>
        </Box></>)
    }

    return (
        <>
            <Box margin={'0 auto'} mt={"1em"} width={{ base: '85%', md: '66%', lg: '50%' }}>
                <Tag backgroundColor={'white'}>
                    <Breadcrumb separator={<ChevronRightIcon color='gray.500' />}>
                        <BreadcrumbItem>
                            <BreadcrumbLink as={RouterLink} to={`/`}>Home</BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <BreadcrumbLink>Reject Part</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Tag>
            </Box>
            <Box margin={'1em auto'} width={{ base: '85%', md: '66%', lg: '50%' }}
                p={4}
                borderWidth="1px"
                rounded="lg"
                shadow="1px 1px 3px rgba(0,0,0,0.3)"
                bgColor={'#fff'}>
                {authorizedUser ? (<>
                <Heading mb={2} as="h1" size="lg" textAlign="center">
                    Reject Part MCF
                </Heading>
                <Divider />
                <form autoComplete="off">
                    <FormControl isRequired mt={2}>
                        <FormLabel>File Path</FormLabel>
                        <Input isReadOnly onFocus={e => e.target.blur() } variant='filled' name="filePath" type="text" size="sm" defaultValue={form.filePath}/>
                    </FormControl>
                    <FormControl isRequired mt={2}>
                        <FormLabel>File Name</FormLabel>
                        <Input isReadOnly onFocus={e => e.target.blur() } variant='filled' name="fileName" type="text" size="sm" defaultValue={form.fileName}/>
                    </FormControl>
                    <FormControl mt={2}>
                        <FormLabel>Reason/Recommendations</FormLabel>
                        <InputGroup size='md'>
                            <Input
                                ref={reasonInputRef}
                                pr='4.5rem'
                                type='text'
                                placeholder='Add a reason or recommendation' 
                            />
                            <InputRightElement width='4.5rem'>
                                <Button outlineColor={highlightButton ? 'red' : 'transparent'} h='1.75rem' size='sm' onClick={handleAddReason}>
                                Add
                                </Button>
                            </InputRightElement>
                        </InputGroup>
                    </FormControl>
                    {reasons.map((e, i) => {
                            return (
                            <Card mt={2} size="sm" key={i}>
                                <CardBody>
                                    <Flex>
                                        <Text>{e}</Text>
                                        <Spacer/>
                                        <CloseButton onClick={() => {setReasons(reasons.filter((reason, index) =>  index !== i ))}}/>
                                    </Flex>
                                </CardBody>
                            </Card>)
                    })}
                    <Button
                        isLoading={loading}
                        name="submitButton"
                        loadingText='Rejecting'
                        colorScheme="red"
                        width="full"
                        mt="4"
                        onClick={handleSubmit}
                    >
                        Reject
                    </Button>
                </form>
                </>
                ) : (<><Center>Not Authorizied</Center></>)}
            </Box>
        </>
    );
}
